import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkConfig } from '../../async-thunk-config';
import apiManager from '../../../api/api-manager';
import { UserState } from '../../data';
import { WebCollaborationState } from './web-collaboration-types';
import { WebCollaborationAnswerRequest, WebCollaborationOfferRequest, WebCollaborationRoomStatus, WebCollaborationIceCandidateRequest } from '../../../api/generated';
import { getAPIRequestHeaders } from '../../../utils/api-utils';

export const getWBStatus = createAsyncThunk<
WebCollaborationRoomStatus,
  void,
  AsyncThunkConfig<string>
>('web-collaboration-get-status', async (_, thunkApi) => {
  try {
    const userState: UserState =
        thunkApi.getState().data.user;
    const wbState: WebCollaborationState =
        thunkApi.getState().features.webCollaboration;
    const response = await apiManager.webCollaborationApi.webCollaborationRoomIdStatusGet(
      userState.isProspect ? 'prospect' : 'consultant',
      wbState.roomId,
      getAPIRequestHeaders(thunkApi)
    );
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const postWBOffer = createAsyncThunk<
  void,
  WebCollaborationOfferRequest,
  AsyncThunkConfig<string>
>('web-collaboration-post-offer', async (request: WebCollaborationOfferRequest, thunkApi) => {
  try {
    const wbState: WebCollaborationState =
        thunkApi.getState().features.webCollaboration;
    await apiManager.webCollaborationApi.postOffer(
          wbState.roomId,
          request,
          getAPIRequestHeaders(thunkApi)
        );
    return null;
  } catch (error) {
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const postWBAnswer = createAsyncThunk<
  void,
  WebCollaborationAnswerRequest,
  AsyncThunkConfig<string>
>('web-collaboration-post-answer', async (request, thunkApi) => {
  try {
    const wbState: WebCollaborationState =
        thunkApi.getState().features.webCollaboration;
    await apiManager.webCollaborationApi.postAnswer(
          wbState.roomId,
          request,
          getAPIRequestHeaders(thunkApi)
        );
    return null;
  } catch (error) {
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
export const postWBCandidate = createAsyncThunk<
  void,
  WebCollaborationIceCandidateRequest,
  AsyncThunkConfig<string>
>('web-collaboration-post-candidate', async (request, thunkApi) => {
  try {
    const wbState: WebCollaborationState =
        thunkApi.getState().features.webCollaboration;
    await apiManager.webCollaborationApi.postIceCandidate(
          wbState.roomId,
          request,
          getAPIRequestHeaders(thunkApi)
        );
    return null;
  } catch (error) {
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const acceptWBAnswer = createAsyncThunk<
  void,
  void,
  AsyncThunkConfig<string>
>('web-collaboration-accept-answer', async (_, thunkApi) => {
  try {
    const wbState: WebCollaborationState =
        thunkApi.getState().features.webCollaboration;
    await apiManager.webCollaborationApi.postAccept(
          wbState.roomId,
          getAPIRequestHeaders(thunkApi)
        );
    return null;
  } catch (error) {
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

export const createRoom = createAsyncThunk<
  string,
  void,
  AsyncThunkConfig<string>
>('web-collaboration-create-room', async (_, thunkApi) => {
  try {
    const response = await apiManager.webCollaborationApi.createRoom(getAPIRequestHeaders(thunkApi));
    return response.data?.roomId;
  } catch (error) {
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
